import axios from 'axios';
import HTTP from 'services/http';
import {
  ICreatePresignedUploadPayload,
  IFileImportFileTracker,
  IPresignedUploadResponse,
} from './types';

const BASE_URL = '/app-manager/file-import';

export const createPresignedUpload = async (
  payload: ICreatePresignedUploadPayload,
): Promise<IPresignedUploadResponse> => {
  const response = await HTTP.post(`${BASE_URL}/upload`, payload);
  return response.data;
};

export const uploadFileToS3 = async (
  url: string,
  fields: Record<string, string>,
  file: File,
): Promise<void> => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append('file', file);

  await axios.post(url, formData);
};

export const getFiles = async (
  customerId: number,
  fileType?: string,
  frequency?: string,
): Promise<IFileImportFileTracker[]> => {
  const params: Record<string, string | number> = { customer_id: customerId };
  if (fileType) {
    params.file_type = fileType;
  }
  if (frequency) {
    params.frequency = frequency;
  }
  const response = await HTTP.get(`${BASE_URL}/files`, { params });
  return response.data;
};
